/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
export const win = typeof window !== 'undefined' ? window : undefined;
export const doc = typeof document !== 'undefined' ? document : undefined;
